"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableCell = _interopRequireDefault(require("./TableCell"));
var _TableRow = _interopRequireDefault(require("./TableRow"));
var _TableFooter = _interopRequireDefault(require("./TableFooter.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var TableFooter = function TableFooter(_ref) {
  var headLabels = _ref.headLabels,
    footerCells = _ref.footerCells,
    cellProps = _ref.cellProps,
    stickyFooter = _ref.stickyFooter;
  var tableKeys = Object.keys(headLabels);
  return /*#__PURE__*/_react["default"].createElement(_TableFooter["default"], {
    enableStickyFooter: stickyFooter
  }, /*#__PURE__*/_react["default"].createElement(_TableRow["default"], null, tableKeys.map(function (key) {
    var extraProps = cellProps ? cellProps[key] : null;
    return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], _extends({
      key: "cell-".concat(key)
    }, extraProps), footerCells[key]);
  })));
};
exports.TableFooter = TableFooter;
TableFooter.propTypes = {
  headLabels: _propTypes["default"].shape({}).isRequired,
  cellProps: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({})]))),
  footerCells: _propTypes["default"].shape({}).isRequired,
  stickyFooter: _propTypes["default"].bool
};
TableFooter.defaultProps = {
  cellProps: null,
  stickyFooter: false
};
TableFooter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableFooter",
  "props": {
    "cellProps": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "objectOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "number"
            }, {
              "name": "string"
            }, {
              "name": "bool"
            }, {
              "name": "shape",
              "value": {}
            }]
          }
        }
      },
      "required": false
    },
    "stickyFooter": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "headLabels": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "footerCells": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};
var _default = TableFooter;
exports["default"] = _default;